<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="table-container">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>

    <div class="">
      <div class="d-flex gap-2 action-buttons-container">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addOptionFunc()"
          (keydown.enter)="addOptionFunc()" matTooltip="Add Options">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)" matTooltip="Audit Trail">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
          (keydown.enter)="refreshGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>

  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px; text-align: center;">

    </th>
    <th style="min-width: 140px;max-width: 140px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Option Code</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>

      </div>
    </th>
    <th style="min-width: 520px;max-width: 520px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>Option Value</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th id="menu" class="sticky-col first-col"></th>
    <!-- search input row is added -->
    <tr *ngFor="let option of optionsList | searchFilter : searchValue; let idx = index;">
      <td style="width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="option.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, option, idx)">
          </div>
        </div>
      </td>
      <td style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{option.optionCode}}</span></td>
      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
         white-space: 'nowrap'"><span>{{option.optionValue}}</span></td>

      <td class="sticky-col first-col">
        <div class="action-icons">
          <i class="fa-sharp fa-solid fa-trash" title="Delete" style="margin-left: 5px;"
            (click)="openDeletePopup(option)" (keydown.enter)="openDeletePopup(option)"></i>
          <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
            style="margin-left: 5px;" (click)="openAuditTrail('individual',option)"
            (keydown.enter)="openAuditTrail('individual',option)"></i>
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center" *ngIf="optionsList.length">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>
<ng-template #addOrEditOptionPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row">
        <div class="col-md-3"><label for="optionCode ">Option Code</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9"> <input id="optionCode" class="input-filed-continers" type="text"
            [(ngModel)]="optionData.optionCode" style="height: 80% !important;">
        </div>
        <span style="margin-left: 25%;" id="optionCode-required-msg">Please enter option code</span>
      </div>
      <div class="row">
        <div class="col-md-3"><label for="optionValue ">Option Value</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9"> <textarea id="optionValue" rows="6" class="input-filed-textarea" type="text"
            [(ngModel)]="optionData.optionValue"></textarea>
        </div>
        <span style="margin-left: 25%;" id="optionValue-required-msg">Please enter option value</span>
      </div>
    </div>
  </div>
  <br>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(optionData)" (keydown.enter)="addAndEditFunction(optionData)"
      *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(optionData)" (keydown.enter)="addAndEditFunction(optionData)"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deleteOptionPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label for="deleteReason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteReason" rows="6" class="textarea-filed-continers" ype="text"
            [(ngModel)]="optionData.deleteReason"></textarea>
          <span id="deleteReason-required-msg">Please enter reason for delete</span>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
